import Flickity from 'flickity';
/* eslint-disable no-unused-vars */
import asNavFor from 'flickity-as-nav-for';

class FilterCarousel {
  constructor() {
    this._cacheSelectors();
    this._getOptions();
    this._init();
  }

  _cacheSelectors() {
    this._carousel = document.querySelector('.carousel');
  }

  _init() {
    this.flkty = new Flickity(this._carousel, this._options);
  }

  _getOptions() {
    if (matchMedia('screen and (min-width: 768px)').matches) {
      this._options = {
        cellSelector: '.carousel-cell',
        cellAlign: 'center',
        groupCells: true,
        contain: true,
        pageDots: false,
        prevNextButtons: true,
        percentPosition: false,
        imagesLoaded: true,
      };
    } else {
      this._options = {
        cellSelector: '.carousel-cell',
        cellAlign: 'left',
        groupCells: false,
        contain: true,
        pageDots: false,
        prevNextButtons: true,
        percentPosition: false,
        imagesLoaded: true,
      };
    }
  }
}

export default FilterCarousel;
